import type { components } from './schema';
import type { SpreadMode, SpreadTypeId } from '@/types';

type JobType = components['schemas']['JobType'];
type LayoutTypeString = components['schemas']['LayoutTypeString'];
type Rating = components['schemas']['Rating'];

export const modeToJobType: Record<SpreadMode, JobType> = {
  'photo-reading': 'PHOTO_READING',
  'person-photo': 'GENERATE_BY_PHOTO',
  generate: 'GENERATE_RANDOM',
};

/**
 * Maps the UI spread tile id to the backend `CARD_LAYOUT` label.
 * `auto-photo` is used with `PHOTO_READING` where the backend model detects
 * the layout from the image — `Custom` is the neutral sentinel.
 */
export const spreadIdToLayout: Record<SpreadTypeId, LayoutTypeString> = {
  'auto-photo': 'Custom',
  'classic-3': '3 Cards',
  'cross-4': 'Cross',
  horseshoe: 'Horse Shoe',
};

export const layoutToSpreadId: Record<LayoutTypeString, SpreadTypeId> = {
  Custom: 'auto-photo',
  '3 Cards': 'classic-3',
  Cross: 'cross-4',
  'Celtic Cross': 'cross-4',
  'Horse Shoe': 'horseshoe',
};

export type UiRating = 'up' | 'mid' | 'down';

export const uiRatingToApi: Record<UiRating, Rating> = {
  up: 'good',
  mid: 'neutral',
  down: 'bad',
};

export const apiRatingToUi: Record<Rating, UiRating> = {
  good: 'up',
  neutral: 'mid',
  bad: 'down',
};
